<template>
  <div>
    <li class="as_li">
      <div class="fl">
        <i class="iconfont">&#xe620;</i>
        <span>发布身份</span>
      </div>
      <div class="check_box fr">
        <div :class="{ active: change_status }" @click="changeP">
          <input type="radio" class="check_in" name="radio" id="ra1" value="1" />
          <label for="ra1">
            <span :class="{ inner: true, inner_active: change_status }">
              <span :class="{ inner_in: change_status }"></span>
            </span>
            个人身份
          </label>
        </div>
        <div :class="{ active: !change_status }" @click="changeO">
          <input type="radio" class="check_in" name="radio" id="ra2" value="3" />
          <label for="ra2">
            <span :class="{ inner: true, inner_active: !change_status }">
              <span :class="{ inner_in: !change_status }"></span>
            </span>
            组织身份
          </label>
        </div>
      </div>
    </li>
    <li class="as_li" @click="changeOrg" v-show="!change_status">
      <div class="fl">
        <i class="iconfont">&#xe649;</i>
        <span>代表组织</span>
      </div>
      <div class="fr">
        <span>{{ org_name }}</span>
        <div class="jt"></div>
      </div>
    </li>
    <div class="mask" v-show="muta_status" @click="mask_status">
      <div style="width:100%">
        <div class="boxtitle" v-show="choose_org_status">请选择代表组织</div>
        <div class="selidbox" id="selidbox">
          <el-radio-group
            v-model="radio2"
            size="medium"
            @change="change_org"
            v-show="choose_org_status"
          >
            <el-radio
              v-for="(item, index) in orgArr"
              :key="index"
              :label="parseInt(item.orgid)"
              border
            >{{ item.orgname }}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "umMidentity",
  data() {
    return {
      choose_org_status: false,
      orgArr: [],
      org_name: "",
      type: 1,
      radio2: 0,
      muta_status: false,
      change_status: true
    };
  },
  props: ["status", "orgId"],
  mounted() {
    this.getList();
  },
  watch: {
    status(val) {
      if (val == "1") {
        this.change_status = true;
      } else {
        this.change_status = false;
      }
    },
    orgId(val) {
      this.getList();
    },
    releaseitem(val) {
      if (!this.change_status) {
        this.orgArr.forEach(m => {
          if (m.orgid == this.orgId) {
            this.org_name = m.orgname;
            this.orgId = m.orgid;
          }
        });
      }
    }
  },
  methods: {
    getList() {
      var that = this;
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "userlist_getusermangerrange",
            type: 3,
            umid: $UMCore.uncompile("umid")
          })
        })
        .then(function(response) {
          that.orgArr = response.data.mangerlist.orglist;
          if (that.orgId) {
            that.orgArr.forEach((m, i) => {
              if (that.orgId == m.orgid) {
                that.org_name = m.orgname;
              }
            });
          } else {
            that.org_name = that.orgArr[0].orgname;
          }
          that.radio2 = parseInt(that.orgArr[0].orgid);
          that.$forceUpdate();
        })
        .catch(function(error) {
          return false;
        });
    },
    changeP() {
      this.type = 1;
      this.change_status = true;
      this.$emit("chooseorgid", "1");
    },
    changeO() {
      this.type = 3;
      this.change_status = false;
      this.$emit("chooseorgid", "3");

      this.changeOrg();
    },
    change_org(val) {
      $("#selidbox").css("height", "220px");
      this.orgArr.forEach((m, i) => {
        if (m.orgid == val) {
          this.org_name = m.orgname;
          this.orgId = val;
        }
      });
      this.$emit("chooseorgid", "3", this.orgId, this.org_name);
    },
    changeOrg() {
      this.muta_status = true;
      this.choose_org_status = true;
    },
    mask_status() {
      this.muta_status = false;
      this.choose_org_status = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  .boxtitle {
    text-align: center;
    line-height: 40px;
    width: 73.3%;
    background: #fff;
    font-size: 16px;
    margin: 0 auto;
    border-radius: 3px 3px 0 0;
  }
  .selidbox {
    // position: absolute;
    height: 220px;
    width: 73.3%;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    margin: auto;
    background: #fff;
    border-radius: 0 0 3px 3px;
    padding: 0 15px 20px;
    font-size: 15px;
    overflow-y: auto;
  }
}
.check_box {
  // width: 100%;
  display: flex;
  // margin-top: 60px;
  // border-bottom: 1px solid #EDEDED;
  div {
    flex: 1;
    font-size: 15px;
    text-align: center;
    // padding: 10px 0;
    .check_in {
      opacity: 0;
    }
    .inner {
      width: 14px;
      height: 14px;
      display: inline-block;
      border-radius: 50%;
      position: relative;
      border: 1px solid #ccc;
      .inner_in {
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #2e9cf1;
        padding: 3px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .inner_active {
      border: 1px solid #2e9cf1 !important;
    }
  }
  .active {
    color: #2e9cf1;
  }
}
.as_li {
  width: 100%;
  float: left;
  font-size: 15px;
  padding: 15px;
  border-bottom: 1px solid #ededed;
}
</style>


// WEBPACK FOOTER //
// src/packages/midentity/um-midentity.vue